(() => {
  const nextCourierDay = date => {
    const next = new Date(date);
    do { next.setUTCDate(next.getUTCDate() + 1); } while (next.getUTCDay() === 0);
    return next;
  };
  function init(root = document) {
    root.querySelectorAll('[data-delivery]').forEach(el => {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      const label = date => new Intl.DateTimeFormat('ro-RO', {day:'numeric',month:'short',timeZone:'UTC'}).format(date);
      function tick() {
        if (!el.isConnected) return;
        const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/Bucharest',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date()).map(p => [p.type,p.value]));
        const ordered = new Date(Date.UTC(+parts.year,+parts.month-1,+parts.day));
        const ship = nextCourierDay(ordered);
        const shipLatest = nextCourierDay(ship);
        const earliest = nextCourierDay(ship);
        const latest = nextCourierDay(shipLatest);
        el.querySelector('[data-order-date]').textContent = label(ordered);
        el.querySelector('[data-ship-date]').textContent = label(ship) + ' – ' + label(shipLatest);
        el.querySelector('[data-delivery-date]').textContent = label(earliest) + ' – ' + label(latest);
        setTimeout(tick,60000);
      }
      tick();
    });
  }
  init();
  document.addEventListener('shopify:section:load',event => init(event.target));
})();
